import React from 'react';
import { NavLink, RouteComponentProps, withRouter } from 'react-router-dom';
import styled from 'styled-components';
import { INTERNAL_LINKS } from '../utils/links';
import { THEME_COLORS } from '../utils/theme';
import { IconClose, IconMenu } from './icons';
import { LogoFont } from './styles';
import mlhBadge from '../assets/mlh-trust-badge-2022-white.svg';

const NavToggleIcon = styled.div`
  position: absolute;
  left: 20px;
  top: 20px;
  padding: 10px;

  &:hover {
    cursor: pointer;
  }
`;

const NavSheetContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;

  background: ${THEME_COLORS.background};

  z-index: 1000;
`;

const LinkContainer = styled.div`
  width: 100vw;
  height: 100vh;

  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;
`;

const StyledNavLink = styled(NavLink)`
  text-decoration: none;
  padding: 20px;
  color: ${THEME_COLORS.text};
  font-size: 2.5rem;
`;

const NavLogo = styled(LogoFont)`
  position: absolute;
  display: block;
  margin-top: 23px;
  text-align: center;
  width: 100%;

  pointer-events: none;

  font-size: 40px;
`;

class MobileNavBase extends React.Component<RouteComponentProps, { isOpen: boolean }> {
  constructor(props: RouteComponentProps) {
    super(props);
    this.state = {
      isOpen: false,
    };
  }

  setIsOpen = (open: boolean) => {
    this.setState({ isOpen: open });
    if (open) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'visible';
    }
  };

  open = () => this.setIsOpen(true);

  close = () => this.setIsOpen(false);

  componentWillUnmount() {
    this.close(); // Ensure we don't lock scroll when the page resizes
  }

  render() {
    if (this.state.isOpen) {
      return (
        <NavSheetContainer>
          <NavToggleIcon onClick={this.close}>
            <IconClose size={30} color={'white'} />
          </NavToggleIcon>
          <NavLogo>DUBHACKS</NavLogo>
          <LinkContainer>
            <StyledNavLink to={INTERNAL_LINKS.HOME} exact onClick={this.close}>
              Home
            </StyledNavLink>
            <StyledNavLink to={INTERNAL_LINKS.ATTEND} exact onClick={this.close}>
              Attend
            </StyledNavLink>
            <StyledNavLink to={INTERNAL_LINKS.COVID} exact onClick={this.close}>
              COVID-19
            </StyledNavLink>
          </LinkContainer>
        </NavSheetContainer>
      );
    } else {
      return (
        <>
          <NavToggleIcon onClick={this.open}>
            <IconMenu size={30} color={'white'} />
          </NavToggleIcon>
          {this.props.location.pathname === '/' ? null : <NavLogo>DUBHACKS</NavLogo>}
          <a
            id="mlh-trust-badge"
            style={{
              display: 'block',
              position: 'absolute',
              right: '25px',
              top: 0,
              zIndex: 10000,
            }}
            href="https://mlh.io/seasons/2022/events?utm_source=na-hackathon&utm_medium=TrustBadge&utm_campaign=2022-season&utm_content=white"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={mlhBadge} alt="Major League Hacking 2022 Hackathon Season" width={60} height={105} />
          </a>
        </>
      );
    }
  }
}

export const MobileNav = withRouter(props => <MobileNavBase {...props} />);
